/** Shared toolbar controls for DORA time-series charts. */

export const CHART_TOOLBAR_ROW_CLASS = 'flex shrink-0 flex-nowrap items-center gap-1.5';

export const CHART_TOOLBAR_SELECT_CLASS = 'select-chart-toolbar';

export const chartToolbarToggleBtnClass = (active) =>
  `inline-flex h-full items-center px-2.5 text-xs font-medium leading-none transition-colors ${
    active
      ? 'bg-dark-base text-slate-100'
      : 'bg-dark-elevated text-slate-300 hover:bg-dark-base hover:text-white'
  } disabled:opacity-60`;

export const CHART_TOOLBAR_TOGGLE_GROUP_CLASS =
  'inline-flex h-8 shrink-0 items-stretch overflow-hidden rounded-lg border border-dark-border';
